import Modal from './Modal';
import confirm from './core/confirm';
import {
    modalWarn,
    withConfirm, withError, withInfo, withSuccess,
} from './types';
import { confirmProps, defaultConfig } from './constants';

type ModalComponent = typeof Modal & {
    info: (props: any) => void;
    success: (props: any) => void;
    error: (props: any) => void;
    confirm: (props: any) => void;
    warning: typeof modalWarn;
    warn: typeof modalWarn;
};

const EnhancedModal = Modal as ModalComponent;

EnhancedModal.info = (props) => confirm(
    withInfo({ ...defaultConfig, ...props }),
);
EnhancedModal.success = (props) => confirm(
    withSuccess({ ...defaultConfig, ...props }),
);
EnhancedModal.error = (props) => confirm(
    withError({ ...defaultConfig, ...props }),
);
EnhancedModal.confirm = (props) => confirm(
    withConfirm({ ...confirmProps, ...defaultConfig, ...props }),
);
EnhancedModal.warning = modalWarn;
EnhancedModal.warn = modalWarn;


export default EnhancedModal;
